import React, { Component } from 'react';
import { AlarmCloseCode, AlarmCloseCodeStatus } from '../../../../../domain/case/CaseDomains';
import EmptyListComponent from '../../../../custom/empty-components/EmptyListComponent';
import CustomTable from '../../../../custom/CustomTable';
import DomainConfigurationReasonCreatorComponent from './DomainConfigurationReasonCreatorComponent';
import { ColumnProps } from 'primereact/column';
import RoleHelper from '../../../../../RoleHelper';
import { customConfirm } from '../../../../custom/CustomPopupConfirm';
import Icon from '../../../../../icons/Icon';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { RootState } from '../../../../../redux/store';
import { ConfigurationState } from '../../../../../redux/reducers/ConfigurationReducer';
import { changeConfiguration } from '../../../../../redux/actions/ConfigurationActions';
import { User } from '../../../../../domain/rbac/RbacDomains';
import LanguageUtil from '../../../../../util/LanguageUtil';

class DomainConfigurationReasonComponent extends Component<Props> {
  public render() {
    const {
      configuration: { configuration },
      changeConfiguration,
    } = this.props;
    return (
      <div className={'flex flex-col w-full h-full min-h-0 2xl:p-5 p-4 overflow-hidden'}>
        <div className={'flex-shrink-0'}>
          <DomainConfigurationReasonCreatorComponent domainConfiguration={configuration} changeDomain={changeConfiguration} />
        </div>
        <div className={'h-full w-full overflow-hidden pb-4 2xl:pb-5'}>
          {configuration.closeCodes.length == 0 ? (
            <EmptyListComponent />
          ) : (
            <CustomTable value={configuration.closeCodes} columns={this.getColumns()} />
          )}
        </div>
      </div>
    );
  }

  private getColumns = (): ColumnProps[] => {
    return [
      {
        field: 'code',
        header: LanguageUtil.get({ id: 'pages.configuration.reason.table.code', defaultMessage: 'Name' }),
        className: 'w-1/3',
        body: (record: AlarmCloseCode) => {
          return <span>{record.code}</span>;
        },
      },
      {
        field: 'status',
        header: LanguageUtil.get({ id: 'pages.configuration.reason.table.status', defaultMessage: 'Status' }),
        className: 'w-1/4',
        body: (record: AlarmCloseCode) => {
          return <span>{this.getStatus(record.status)}</span>;
        },
      },
      {
        field: 'action',
        header: LanguageUtil.get({ id: 'pages.configuration.reason.table.action', defaultMessage: 'Action' }),
        className: 'max-w-[75px] 2xl:max-w-[100px]',
        alignHeader: 'left',
        sortable: false,
        body: (record: AlarmCloseCode) => {
          const disabled = !RoleHelper.canEdit('CaseConfiguration');
          return (
            <div
              onClick={(e: any) => {
                e.stopPropagation();
                e.preventDefault();
                !disabled &&
                  customConfirm({
                    target: e.currentTarget,
                    accept: () => this.removeReason(record),
                    message: LanguageUtil.get({ id: 'messages.confirm.removeVariable', defaultMessage: 'Are you sure remove this variable?' }),
                  });
              }}
            >
              <Icon icon={'delete'} size={20} className={`${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} text-f-black-3`} />
            </div>
          );
        },
      },
    ];
  };

  private removeReason = (closeCode: AlarmCloseCode) => {
    const {
      configuration: { configuration },
      changeConfiguration,
    } = this.props;
    const { closeCodes } = configuration;
    if (!RoleHelper.canEdit('CaseConfiguration')) return;
    const index = closeCodes.indexOf(closeCode);
    if (index != -1) {
      closeCodes.splice(index, 1);
      changeConfiguration(configuration);
    }
  };

  private getStatus = (status: AlarmCloseCodeStatus) => {
    switch (status) {
      case 'COMPLIANT':
        return LanguageUtil.get({ id: 'common.label.compliant', defaultMessage: 'Compliant' });
      case 'IN_COMPLIANT':
        return LanguageUtil.get({ id: 'common.label.inCompliant', defaultMessage: 'In Compliant' });
      case 'FRAUD':
        return LanguageUtil.get({ id: 'common.label.fraud', defaultMessage: 'Fraud' });
      case 'NOT_FRAUD':
        return LanguageUtil.get({ id: 'common.label.notFraud', defaultMessage: 'Not Fraud' });
      case 'HOLD':
        return LanguageUtil.get({ id: 'common.label.onHold', defaultMessage: 'On Hold' });
    }
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  lastCategory: state.page.lastCategory,
  page: state.page,
  filter: state.page.filter,
  configuration: state.configuration as ConfigurationState,
  user: state.auth.user as User,
});

const mapDispatchToProps = {
  changeConfiguration,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(DomainConfigurationReasonComponent);
